import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from './button';

class Modal extends Component {
  handleClose = () => {
   this.props.close();
  };

  handleConfirm = () => {
   this.props.confirm();
  };

  render() {
    return (
      <Dialog
      open={this.props.open}
      onClose={this.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
      <DialogContent>
          {this.props.content}
      </DialogContent>
      <DialogActions>
        <Button label={this.props.secondaryButton} className={this.props.secondaryButton==="null"?'hide':'btn btn-default'} onClick={this.handleClose} data-testid="modal-cancel" />
        <Button label={this.props.primaryButton} className='btn btn-action' onClick={this.handleConfirm} data-testid="modal-confirm" />

      </DialogActions>
    </Dialog>
    );
  }
}


export default Modal;
